export const ARCHIVED_LABEL = ' [ARCHIVED]';
